import { useState } from 'react'

import kickoffPhoto from 'assets/images/projectSetup/kickoff.png'
import { kickoffIntro, kickoffParagraphs } from 'constants/ProjectSetUpConstants'

import { KickoffSessionModal } from './KickoffSessionModal'

export const HoldKickoffPanel = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <div className="setup-panel-surface flex gap-6 items-start">
      <img src={kickoffPhoto} alt="Team holding a kickoff session" className="kickoff-photo shrink-0" />

      <div className="flex flex-col justify-between items-end flex-1 self-stretch">
        <div className="flex flex-col gap-4 items-start w-full">
          <p className="body-l w-full">{kickoffIntro}</p>
          <div className="flex flex-col gap-2 items-start w-full">
            {kickoffParagraphs.map(paragraph => (
              <p key={paragraph} className="body-xs w-full">
                {paragraph}
              </p>
            ))}
          </div>
        </div>

        <button className="setup-cta-button" onClick={() => setIsModalOpen(true)}>
          Open guide
        </button>
      </div>

      <KickoffSessionModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  )
}
